export const GAME_EVENTS = {
    GET_INITIAL_GAME_DATA: 'GET_INITIAL_GAME_DATA',
    JOIN_LOBBY: 'JOIN_LOBBY',
    NEW_VISITOR: 'NEW_VISITOR',
    NEW_PLAYER: 'NEW_PLAYER',
    GAME_START: 'GAME_START',
    RESTART_GAME: 'RESTART_GAME',
    VISITOR_OR_PLAYER_LEFT: 'VISITOR_OR_PLAYER_LEFT',
    UPDATE_GAME_DATA: 'UPDATE_GAME_DATA',
    GAME_DATA_CHANGED: 'GAME_DATA_CHANGED',

    NEW_VISITOR_VIDEO: 'NEW_VISITOR_VIDEO',
    NEW_PLAYER_VIDEO: 'NEW_PLAYER_VIDEO',
    CHESS_CONTROLLER_CONNECTED: 'CHESS_CONTROLLER_CONNECTED',

    CHESS_GAME_LOCKED: 'CHESS_GAME_LOCKED',
    CHESS_GAME_UNLOCKED: 'CHESS_GAME_UNLOCKED',

    ERROR: 'ERROR',
    VISITOR_TAKE_SEAT: 'VISITOR_TAKE_SEAT',
    CHESS_CONTROLLER_ROOM_LEFT: 'CHESS_CONTROLLER_ROOM_LEFT',
    GET_VISITORS_TAKEN_SEATS: 'GET_VISITORS_TAKEN_SEATS',
}


export const USER_CLICKED_GAME_EVENT = {
    LOCK: 'LOCK',
    UNLOCK: 'UNLOCK',
    HISTORY: 'HISTORY',
}